<div class="page-breadcrumb">
  <ng-container *ngFor="let breadCrumbName of breadcrumbs; let last = last">
	<a *ngIf="!last" [routerLink]="breadCrumbName.url"> {{ breadCrumbName.label }}</a>

    <span *ngIf="last" class="active">{{ breadCrumbName.label }} </span>
    <span *ngIf="!last" class="divider ms-2">
     <i class="bi bi-arrow-right"></i></span>
  </ng-container>
</div>
